import { Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-success-modal',
  standalone: true,
  imports: [NgOptimizedImage, TranslateModule],
  templateUrl: './success-modal.component.html',
  styleUrl: './success-modal.component.scss',
})
export class SuccessModalComponent {
  @Input({ required: true }) description =
    'front.success-modal.your-request-has-been-sent';
}
